/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum supportIncludeEnum {
    ALL = 'all',
    SUPPORT = 'support',
    LIVE = 'live',
}